<template>
  <div class="page">
    <div class="title">
      <h3>身份核验</h3>
    </div>
    <div class="desc">
      为了您的账号和资金安全，根据《网络安全法》与《服务协议》对您的账户和交易进行身份核验。请提提供您的姓名和身份证号码进行身份核验，请确保您提供的信息真实有效。
    </div>
    <van-field v-model="name" placeholder="姓名" />
    <van-field v-model="idCard" placeholder="身份证号" />
    <van-field v-model="code" placeholder="验证码">
    <template #extra>
        <img :src="kaptchaUrl" width="100" height="40" @click="refreshCode" />
    </template>
    </van-field>
    <div style="margin-top:30px;">
      <van-button type="primary" style="width:100%;" @click="commit"
        >提交</van-button
      >
    </div>
  </div>
</template>

<script>
import { Field, Button, Toast, Dialog } from "vant";
import userApi from "@/api/user";

export default {
  name: "UserValidate",

  components: {
    [Field.name]: Field,
    [Button.name]: Button,
    [Toast.name]: Toast,
    [Dialog.name]: Dialog,
  },

  data() {
    return {
      kaptchaUrl: "/api/kaptcha",
      userId: "",
      phone: "",
      name: "",
      idCard: "",
      code: "",
    };
  },

  mounted() {
    this.userId = this.$store.state.user.user.id;
  },

  methods: {
    commit() {
      if (!this.name) {
        Toast("请填写姓名！");
        return false;
      }
      if (!this.idCard) {
        Toast("请填写身份证号！");
        return false;
      }
      if (!this.code) {
        Toast("请填写验证码！");
        return false;
      }
      userApi
        .validate(this.userId, {
          phone: this.phone,
          name: this.name,
          idCard: this.idCard,
          code: this.code,
        })
        .then((res) => {
          if (res.success) {
            Toast.success("身份核验成功！");
            userApi.getCurrentUser().then((res) => {
              if (res.success) {
                this.$store.commit("setUser", res.data);
              } else {
                this.$store.commit("setUserState", 1);
              }
              this.$router.back();
            });
          } else {
            Dialog.alert({
              message: res.message,
              confirmButtonColor: "#1989fa",
            });
          }
        });
    },
    refreshCode() {
      this.kaptchaUrl = "/api/kaptcha?d=" + new Date().getTime();
    },
  },
};
</script>

<style scoped>
.page {
  padding: 20px 20px;
}
.title {
  height: 60px;
  text-align: center;
}
.desc {
  margin-bottom: 50px;
  color: #999;
  font-size: 12px;
  text-align: center;
  line-height: 150%;
}
.van-field {
  margin-top: 30px;
}
</style>
